const Stats = () => {
  return (
    <section className="section-padding bg-gray-50">
      <div className="container-custom">
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4 text-center">
          
          {/* Stat 1 */}
          <div>
            <h3 className="text-4xl font-bold text-primary-700 mb-2">
              50+
            </h3>
            <p className="text-gray-600">
              Business Solutions Delivered
            </p>
          </div>

          {/* Stat 2 */}
          <div>
            <h3 className="text-4xl font-bold text-primary-700 mb-2">
              99.9%
            </h3>
            <p className="text-gray-600">
              System Uptime
            </p>
          </div>

          {/* Stat 3 */}
          <div>
            <h3 className="text-4xl font-bold text-primary-700 mb-2">
              24/7
            </h3>
            <p className="text-gray-600">
              Technical Support
            </p>
          </div>

          {/* Stat 4 */}
          <div>
            <h3 className="text-4xl font-bold text-primary-700 mb-2">
              100%
            </h3>
            <p className="text-gray-600">
              Client Satisfaction Focus
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Stats;
